module.exports = __webpack_public_path__ + "img/k3.d2ff612c.webp";